module.exports = __webpack_public_path__ + "static/media/Dialog.7daca567.png";